export const BUSINESS = {
  name: "Mike's Garage Door Repair",
  phone: "(345) 655-4157",
  phoneRaw: "+13456554157",
  email: "dispatch@mikesgaragedoorcypress.com",
  address: "17420 Cypress Rosehill Rd, Cypress, TX 77429",
  city: "Cypress",
  state: "TX",
  hours: "24/7/365 — Always Open",
  license: "TACL #B-1247890",
  rating: "4.9",
  reviewCount: "312",
  yearsInBusiness: "18",
};

export const SERVICES = [
  {
    id: "spring",
    title: "Spring Repair & Replacement",
    short: "Torsion & Extension Springs",
    desc: "Broken garage door spring? Our technicians carry every spring gauge on the truck for same-day torsion and extension spring replacement — calibrated to your door's exact weight.",
    image: "https://media.base44.com/images/public/6a5847080763d214450cfad8/554e076ec_generated_8c3282b5.png",
    keyword: "garage door spring repair Cypress TX",
    priceFrom: "$150",
  },
  {
    id: "motor",
    title: "Opener Repair & Installation",
    short: "Motors, Drives & Logic Boards",
    desc: "LiftMaster, Chamberlain, Genie, Craftsman — we repair and install all opener brands. Chain, belt, and screw drive systems with smart-home programming.",
    image: "https://media.base44.com/images/public/6a5847080763d214450cfad8/ab0dff51f_generated_06592701.png",
    keyword: "garage door opener repair Cypress TX",
    priceFrom: "$120",
  },
  {
    id: "sensor",
    title: "Safety Sensor Alignment",
    short: "Photo-Eye & Laser Sensors",
    desc: "Door won't close? Misaligned or faulty safety sensors are the #1 call we get. We realign, clean, and replace photo-eye sensors to restore safe automatic operation.",
    image: "https://media.base44.com/images/public/6a5847080763d214450cfad8/a1463069b_generated_e64a94a0.png",
    keyword: "garage door sensor repair Cypress TX",
    priceFrom: "$85",
  },
  {
    id: "cable",
    title: "Cable & Off-Track Repair",
    short: "Lift Cables & Track Realignment",
    desc: "Frayed cables and off-track doors are dangerous. We replace lift cables, realign tracks, and replace rollers to get your door sliding smooth and silent again.",
    image: "https://media.base44.com/images/public/6a5847080763d214450cfad8/1a55e3c9e_generated_829c7a39.png",
    keyword: "off-track garage door repair Cypress TX",
    priceFrom: "$95",
  },
  {
    id: "panel",
    title: "Panel & Door Installation",
    short: "Sectional & Full Door Replacement",
    desc: "Dented panels, storm damage, or upgrading your curb appeal? We install steel, glass, and carriage-house doors from leading manufacturers with precision fitment.",
    image: "https://media.base44.com/images/public/6a5847080763d214450cfad8/96af05051_generated_ee7f2ed8.png",
    keyword: "garage door panel replacement Cypress TX",
    priceFrom: "$280",
  },
];

export const NEIGHBORHOODS = [
  "Bridgeland",
  "Towne Lake",
  "Cypress Creek",
  "Coles Crossing",
  "Fairfield",
  "Cypress Lakes",
  "Blackhorse Ranch",
  "Stonegate",
];

export const RECENT_REPAIRS = [
  { time: "23 min ago", neighborhood: "Bridgeland", service: "Torsion Spring Replacement" },
  { time: "1 hr ago", neighborhood: "Towne Lake", service: "Opener Logic Board Swap" },
  { time: "2 hrs ago", neighborhood: "Coles Crossing", service: "Off-Track Door Realignment" },
  { time: "4 hrs ago", neighborhood: "Fairfield", service: "Safety Sensor Replacement" },
  { time: "6 hrs ago", neighborhood: "Cypress Creek", service: "Panel Section Replacement" },
  { time: "8 hrs ago", neighborhood: "Blackhorse Ranch", service: "Lift Cable Replacement" },
];